import React, {Component} from 'react';
import {injectIntl} from 'react-intl';
import connect from 'react-redux/es/connect/connect';
import {Card, List, Row} from "antd";
import {isMobilityRental, OWN_MOBILITY, STEPS_JOURNEY, STEPS_JOURNEY_WITH_RENTAL, WAIT_MOBILITY} from "../../definition/business";
import FieldError from "../../../../components/common/input/FieldError";
import Radio from "../services/Radio"
import {isoDurationToMinutes} from "../../definition/helper";
import Checkbox from '../services/Checkbox'
import PriceTag from '../../../../components/common/pricetag/PriceTag';


class MobilityOptions extends Component {

  constructor(props) {
    super(props)
    this.state = {
      extendedOptions: false,
    }
  }

  renderMobilitySolutions = (mobilityOption, mobilities) => {
    if (!mobilities || mobilities.length === 0) {
      return null;
    }
    const {intl: {formatMessage}} = this.props;
    return (<List
        itemLayout="horizontal"
        dataSource={mobilities}
        renderItem={item => (
          <li className="list" style={{paddingBottom: 25}}>
            <Radio
              id={'mobility_' + item.name}
              name="mobility-solutions"
              checked={mobilityOption === item.name}
              onChange={() => this.onChooseSolution(item.name, item.title)}
            >
              <span>{item.title}</span>
              <span style={{float: 'right'}}><PriceTag price={item.price}/></span>
              <div style={{paddingLeft: '3rem', color: '#6e6e6e'}}>
                <ul className="list">
                  {item.description && <li style={{padding: 0}}>{item.description}</li>}
                  {item.rangeOfKilometers && (
                    <li style={{padding: 0}}>
                      {formatMessage({id: 'customer.journey.step.serviceMobility.rangeLimit'}, {range: item.rangeOfKilometers})}
                    </li>
                  )}
                </ul>
              </div>
            </Radio>
          </li>
        )}
      />
    );
  };

  onChooseSolution = (mobilityOption, mobilityOptionTitle) => {
    if (isMobilityRental(mobilityOption, this.props.customerPreJourneyInfo.mobility.categoryMobility)) {
      this.props.switchSteps({steps: STEPS_JOURNEY_WITH_RENTAL});
    } else {
      this.props.switchSteps({steps: STEPS_JOURNEY});
    }
    this.props.dispatchSaveMobilityOption({mobilityOption, mobilityOptionTitle});
  };

  onToggleWorkspaceReservations = (value) => {
    const {createAppointmentRequest} = this.props;
    this.props.dispatchSaveMobilityOption({...createAppointmentRequest.chosenMobility, workspaceReservations: value});
  }

  renderMobility = (mobility) => {
    const {intl: {formatMessage}, showWorkspaceReservation, maxWaitingTime, createAppointmentRequest: {estimatedTime, chosenMobility}} = this.props;

    const mobilityOption = chosenMobility && chosenMobility.mobilityOption;
    const workspaceReservations = (chosenMobility && chosenMobility.workspaceReservations) || false;
    const shouldShowProvideMobility = mobility.categoryMobility.length > 0 || mobility.extraMobility.length > 0 || mobility.otherMobility.length > 0;
    const shouldShowWait = estimatedTime < maxWaitingTime

    if (!shouldShowWait && chosenMobility && mobilityOption === WAIT_MOBILITY) {
      this.props.dispatchRemoveMobilityOption();
    }

    return (<div className="wrap">
        <div className="content">
          <span>{formatMessage({id: 'customer.journey.step.serviceMobility.mobilityAdvise'})}</span>
          {!mobilityOption && (
            <FieldError error={{message: 'customer.journey.pleaseChoose'}}/>
          )}
          {shouldShowWait && (
            <Row style={{marginTop: 25}}>
              <Row>
                <Radio
                  id={'mobility-wait'}
                  name='mobility-options'
                  checked={mobilityOption === WAIT_MOBILITY && !this.state.extendedOptions}
                  onChange={() => {
                    this.setState({extendedOptions: false});
                    this.onChooseSolution(WAIT_MOBILITY, formatMessage({id: 'customer.journey.step.serviceMobility.mobilityWait'}))
                  }}
                >
                  {formatMessage({id: 'customer.journey.step.serviceMobility.mobilityWait'})}
                </Radio>
              </Row>
              {mobilityOption === WAIT_MOBILITY && showWorkspaceReservation && (
                <Row style={{marginLeft: 30, marginTop: 15}}>
                  <Checkbox
                    id='workspaceReservations'
                    checked={workspaceReservations}
                    onChange={this.onToggleWorkspaceReservations}
                  >
                    {formatMessage({id: 'customer.journey.step.workspaceReservation'})}
                  </Checkbox>
                </Row>
              )}
            </Row>
          )}
          <Row style={{marginTop: 25}}>
            <Radio
              id={'mobility-own'}
              name='mobility-options'
              checked={mobilityOption === OWN_MOBILITY && !this.state.extendedOptions}
              onChange={() => {
                this.setState({extendedOptions: false});
                this.onChooseSolution(OWN_MOBILITY, formatMessage({id: 'customer.journey.step.serviceMobility.mobilityOwn'}))
              }}
            >
              {formatMessage({id: 'customer.journey.step.serviceMobility.mobilityOwn'})}
            </Radio>
          </Row>
          {shouldShowProvideMobility && (
            <React.Fragment>
              <Row style={{marginTop: 25}}>
                <Radio
                  id='mobility-propose'
                  name='mobility-options'
                  checked={this.state.extendedOptions}
                  onChange={() => {
                    this.setState((prevState) => {
                      return {extendedOptions: !prevState.extendedOptions}
                    });
                    this.props.dispatchRemoveMobilityOption();
                  }}
                  disabled={false}
                >
                  {formatMessage({id: 'customer.journey.step.serviceMobility.provideMobility'})}
                </Radio>
              </Row>
              {this.state.extendedOptions && (
                <Row style={{paddingLeft: 20, paddingTop: 20}}>
                  {this.renderMobilitySolutions(mobilityOption, mobility.categoryMobility)}
                  {this.renderMobilitySolutions(mobilityOption, mobility.otherMobility)}
                  {this.renderMobilitySolutions(mobilityOption, mobility.extraMobility)}
                </Row>
              )}
            </React.Fragment>
          )}
        </div>
      </div>
    );
  };

  render() {
    const {intl: {formatMessage}, customerPreJourneyInfo} = this.props;
    return <Card
      title={formatMessage({id: 'section.mobility.title'}).toUpperCase()}
      bordered={false}
      style={{width: '100%'}}
    >
      <div className="wrap">
        <div className="content">
          {this.renderMobility(customerPreJourneyInfo.mobility)}
        </div>
      </div>
    </Card>
  }
}

const mapDispatchToProps = dispatch => ({
  switchSteps: (params) => dispatch({type: 'SAVE.SET_STEPS.REQUEST', params}),
  dispatchSaveMobilityOption: (params) => dispatch({type: 'SAVE.MOBILITY_OPTION', params}),
  dispatchRemoveMobilityOption: (params) => dispatch({type: 'REMOVE.MOBILITY_OPTION'}),
});

const mapStateToProps = state => ({
  selectedDealer: state.customerDealer.selectedDealer,
  customerPreJourneyInfo: state.customerPreJourneyInfo.preJourneyInfo,
  createAppointmentRequest: state.createAppointmentRequest,
  showWorkspaceReservation: state.customerDealer.selectedDealer.receptionOffering.workspaceReservations,
  maxWaitingTime: isoDurationToMinutes(state.customerDealer.selectedDealer.maxWaitingTime)
});

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(MobilityOptions)
);
